export default "__VITE_ASSET__SVk3pdSv__"